// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "gatsby-assets/css/" + "styles" + "." + "df13e7b3117ca63843c7" + ".css";
};